(function () {
  'use strict';

  var BUTTON_ID = 'lifestyle_installation_video'; 
  var ANCHOR_SELECTOR = '.installationMetaEmbed';

  var videosCache = null;
  var videosFetchPromise = null;


  function getYoutubeId(url) {
    if (!url) return null;
    var match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&?/]+)/);
    return match ? match[1] : null;
  }

  function toEmbedUrl(url, mute) {
    if (!url) return '';

    var muteParam = mute ? '&mute=1' : '';


    if (url.indexOf('youtube.com/embed/') !== -1) {
      var separator = url.indexOf('?') !== -1 ? '&' : '?';
      return url + separator + 'autoplay=1&enablejsapi=1' + muteParam + '&origin=' + encodeURIComponent(window.location.origin);
    }

    var id = getYoutubeId(url);
    if (!id) return '';
    return (
      'https://www.youtube.com/embed/' + id +
      '?rel=0&autoplay=1&enablejsapi=1' + muteParam + '&origin=' +
      encodeURIComponent(window.location.origin)
    );
  }

  function toThumbnailUrl(url) {
    var id = getYoutubeId(url);
    return id ? 'https://img.youtube.com/vi/' + id + '/hqdefault.jpg' : '';
  }


  function getVideosJson(jsonUrl) {
    if (videosCache) return Promise.resolve(videosCache);
    if (!jsonUrl) return Promise.resolve(null);
    if (!videosFetchPromise) {
      videosFetchPromise = fetch(jsonUrl)
        .then(function (res) { return res.ok ? res.json() : null; })
        .catch(function () { return null; })
        .then(function (data) {
          videosCache = data;
          return data;
        });
    }
    return videosFetchPromise;
  }


  function whenSwiperReady(callback, attempts) {
    attempts = attempts || 0;
    if (window.Swiper) {
      callback();
      return;
    }
    if (attempts > 80) return; 
    setTimeout(function () { whenSwiperReady(callback, attempts + 1); }, 50);
  }


  function whenInViewport(el, callback) {
    if (!el) return;
    try {
      if (!('IntersectionObserver' in window)) {
        callback();
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.disconnect();
            callback();
          }
        });
      }, { threshold: 0.25 });
      observer.observe(el);
    } catch (e) {
    }
  }

  function armViewportAutoplay(refs) {
    if (refs.__viewportArmed) return;
    refs.__viewportArmed = true;
    whenInViewport(refs.frameEl, function () {
      if (refs.__hasPlayed) return;
      activateSlide(refs);
      addMuteToggle(refs);
    });
  }



  function playUnmuted(refs) {
    var href = refs.iframeEl.dataset.watchUrl;
    if (href) {
      refs.iframeEl.dataset.src = toEmbedUrl(href, false);
    }
    activateSlide(refs);
  }


  function showIframeError(iframe) {
    var watchUrl = iframe.dataset.watchUrl;
    iframe.setAttribute('src', '');

    var frame = iframe.closest('.pc-iv-video-frame');
    if (!frame || frame.querySelector('.pc-iv-error-overlay')) return;

    var overlay = document.createElement('div');
    overlay.className = 'pc-iv-error-overlay';
    overlay.innerHTML =
      '<div class="pc-iv-error-inner">' +
        '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" ' +
        'stroke="currentColor" stroke-width="1.5" stroke-linecap="round">' +
          '<circle cx="12" cy="12" r="10"/>' +
          '<line x1="12" y1="8" x2="12" y2="12"/>' +
          '<circle cx="12" cy="16" r=".5" fill="currentColor"/>' +
        '</svg>' +
        '<p>This video cannot be played on this page.</p>' +
        (watchUrl
          ? '<a class="pc-iv-yt-link" href="' + watchUrl + '" target="_blank" rel="noopener">' +
            "YouTube'da İzle&nbsp;↗</a>"
          : '') +
      '</div>';
    frame.appendChild(overlay);
  }

  var youtubeMessageHandlerAttached = false;

  function ensureYoutubeMessageHandler() {
    if (youtubeMessageHandlerAttached) return;
    youtubeMessageHandlerAttached = true;
    window.addEventListener('message', function (event) {
      if (event.origin !== 'https://www.youtube.com') return;
      var data;
      try {
        data = JSON.parse(event.data);
      } catch (e) {
        return;
      }
      if (data.event === 'onError' && (data.info === 101 || data.info === 150)) {
        document.querySelectorAll('.pc-iv-iframe').forEach(function (iframe) {
          if (iframe.contentWindow === event.source) showIframeError(iframe);
        });
      }
    });
  }


  function buildVideoFrame(opts) {
    // opts: { videoUrl, thumbSrc, yIconEl, disabled, autoplayMuted }
    var frame = document.createElement('div');
    frame.className = 'pc-iv-video-frame';

    var iframe = document.createElement('iframe');
    iframe.className = 'pc-iv-iframe';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'autoplay; encrypted-media');
    iframe.setAttribute('allowfullscreen', '');
    iframe.dataset.src = toEmbedUrl(opts.videoUrl, opts.autoplayMuted);
    iframe.dataset.watchUrl = opts.videoUrl || '';

    var facade = document.createElement('button');
    facade.type = 'button';
    facade.className = 'pc-gallery-facade';
    facade.setAttribute('aria-label', 'Play video');
    if (opts.disabled) facade.setAttribute('aria-disabled', 'true');

    var thumbImg = document.createElement('img');
    thumbImg.className = 'lazy placeHolderVideos';
    thumbImg.loading = 'lazy';
    thumbImg.src = opts.thumbSrc || '';
    thumbImg.alt = '';
    facade.appendChild(thumbImg);

    if (opts.yIconEl) {
      facade.appendChild(opts.yIconEl.cloneNode(true));
    }

    frame.appendChild(iframe);
    frame.appendChild(facade);

    return { frameEl: frame, facadeEl: facade, iframeEl: iframe };
  }


  function addMuteToggle(refs) {
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'pc-iv-mute-toggle is-muted';
    toggle.setAttribute('aria-pressed', 'true');
    toggle.setAttribute('aria-label', 'Unmute video');
    toggle.textContent = '🔇';

    var muted = true;

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      if (!refs.iframeEl.contentWindow) return;
      muted = !muted;
      refs.iframeEl.contentWindow.postMessage(
        JSON.stringify({ event: 'command', func: muted ? 'mute' : 'unMute', args: [] }),
        '*'
      );
      toggle.classList.toggle('is-muted', muted);
      toggle.setAttribute('aria-pressed', String(muted));
      toggle.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      toggle.textContent = muted ? '🔇' : '🔊';
    });

    refs.frameEl.appendChild(toggle);
    return toggle;
  }

  function buildSlide(opts) {
    var slide = document.createElement('div');
    slide.className = 'pc-gallery-slide';
    var refs = buildVideoFrame(opts);
    slide.appendChild(refs.frameEl);
    return { slideEl: slide, frameEl: refs.frameEl, facadeEl: refs.facadeEl, iframeEl: refs.iframeEl };
  }

  function activateSlide(refs) {
    var frame = refs.iframeEl.closest('.pc-iv-video-frame');
    if (frame && frame.querySelector('.pc-iv-error-overlay')) return;
    if (refs.facadeEl.hasAttribute('aria-disabled')) return;
    if (!refs.iframeEl.dataset.src) return;
    refs.iframeEl.setAttribute('src', refs.iframeEl.dataset.src);
    refs.facadeEl.classList.add('is-playing');
    refs.__hasPlayed = true;
  }

  function deactivateSlide(refs) {
    var frame = refs.iframeEl.closest('.pc-iv-video-frame');
    if (frame && frame.querySelector('.pc-iv-error-overlay')) return;
    refs.iframeEl.setAttribute('src', '');
    refs.facadeEl.classList.remove('is-playing');
  }


  function createHeightSync() {
    var desktopQuery = window.matchMedia('(min-width: 769px)');
    var swiperRef = { instance: null };

    function apply() {
      var reactionsFrame = document.querySelector('.p-reactions .pc-iv-video-frame');
      var installFrames = document.querySelectorAll('.p-installations .pc-iv-video-frame');
      if (!reactionsFrame || !installFrames.length) return;

      if (desktopQuery.matches) {
        var h = reactionsFrame.getBoundingClientRect().height;
        if (h > 0) {
          installFrames.forEach(function (frame) {
            frame.style.height = h + 'px';
            frame.style.paddingTop = '0';
          });
        }
      } else {
        installFrames.forEach(function (frame) {
          frame.style.height = '';
          frame.style.paddingTop = '';
        });
      }


      if (swiperRef.instance && typeof swiperRef.instance.update === 'function') {
        swiperRef.instance.update();
      }
    }

    window.addEventListener('resize', apply);

    return {
      apply: apply,
      setSwiper: function (instance) { swiperRef.instance = instance; }
    };
  }


  function buildGallery(container, originalAnchor, videos) {
    var wrap = document.createElement('div');
    wrap.className = 'pc-gallery-wrap';

    var swiperEl = document.createElement('div');
    swiperEl.className = 'pc-gallery-swiper';

    var wrapperEl = document.createElement('div');
    wrapperEl.className = 'pc-gallery-wrapper';

    var yIconEl = originalAnchor.querySelector('.y-icon');
    var placeholderImg = originalAnchor.querySelector('.placeHolderVideos');
    var initialHref = originalAnchor.getAttribute('href') || '';

    var slideRefsList = [];

    var slide0ThumbSrc = placeholderImg
      ? (placeholderImg.dataset.src || placeholderImg.dataset.original ||
         placeholderImg.currentSrc || placeholderImg.src)
      : '';
    var slide0 = buildSlide({
      videoUrl: initialHref,
      thumbSrc: slide0ThumbSrc,
      yIconEl: yIconEl,
      disabled: !initialHref,
      autoplayMuted: true
    });
    wrapperEl.appendChild(slide0.slideEl);
    slideRefsList.push(slide0);

    videos.forEach(function (videoUrl) {
      var slide = buildSlide({
        videoUrl: videoUrl,
        thumbSrc: toThumbnailUrl(videoUrl),
        yIconEl: yIconEl,
        disabled: false
      });
      wrapperEl.appendChild(slide.slideEl);
      slideRefsList.push(slide);
    });

    swiperEl.appendChild(wrapperEl);

    var nextEl = document.createElement('div');
    nextEl.className = 'pc-gallery-next';
    nextEl.setAttribute('aria-hidden', 'true');

    var prevEl = document.createElement('div');
    prevEl.className = 'pc-gallery-prev';
    prevEl.setAttribute('aria-hidden', 'true');

    swiperEl.appendChild(nextEl);
    swiperEl.appendChild(prevEl);

    wrap.appendChild(swiperEl);
    container.insertBefore(wrap, originalAnchor.nextSibling);

    originalAnchor.style.display = 'none';
    originalAnchor.setAttribute('aria-hidden', 'true');
    originalAnchor.setAttribute('tabindex', '-1');

    ensureYoutubeMessageHandler();

    slideRefsList.forEach(function (refs) {
      refs.facadeEl.addEventListener('click', function () {
        slideRefsList.forEach(deactivateSlide);
        playUnmuted(refs);
      });
    });

    var heightSync = createHeightSync();
    heightSync.apply(); 

    var swiperInstance = new window.Swiper(swiperEl, {
      wrapperClass: 'pc-gallery-wrapper',
      slideClass: 'pc-gallery-slide',
      slideActiveClass: 'pc-gallery-slide-active',
      slideNextClass: 'pc-gallery-slide-next',
      slidePrevClass: 'pc-gallery-slide-prev',
      slideVisibleClass: 'pc-gallery-slide-visible',
      slideDuplicateClass: 'pc-gallery-slide-duplicate',
      slideDuplicateActiveClass: 'pc-gallery-slide-duplicate-active',
      slideDuplicateNextClass: 'pc-gallery-slide-duplicate-next',
      slideDuplicatePrevClass: 'pc-gallery-slide-duplicate-prev',
      containerModifierClass: 'pc-gallery-swiper-',
      slidesPerView: 1.15,
      spaceBetween: 12,
      watchOverflow: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
        disabledClass: 'pc-gallery-nav-disabled'
      },
      breakpoints: {
        640: { slidesPerView: 1.25, spaceBetween: 16 }
      },
      on: {
        slideChangeTransitionStart: function () {
          slideRefsList.forEach(deactivateSlide);
        }
      }
    });

    heightSync.setSwiper(swiperInstance);
    heightSync.apply(); 

    setupDynamicHrefVideo(originalAnchor, slide0);

    return swiperInstance;
  }


  function setupDynamicHrefVideo(anchorEl, refs) {
    function applyHref(href) {
      deactivateSlide(refs); 

      if (!href) {
        refs.facadeEl.setAttribute('aria-disabled', 'true');
        refs.iframeEl.dataset.src = '';
        refs.iframeEl.dataset.watchUrl = '';
        return;
      }

      refs.facadeEl.removeAttribute('aria-disabled');

      if (!refs.__hasPlayed) {
        refs.iframeEl.dataset.src = toEmbedUrl(href, true);
        refs.iframeEl.dataset.watchUrl = href;
        armViewportAutoplay(refs);
      } else {
        refs.iframeEl.dataset.src = toEmbedUrl(href, false);
        refs.iframeEl.dataset.watchUrl = href;
      }
    }

    var initialHref = anchorEl.getAttribute('href') || '';
    if (initialHref) applyHref(initialHref);

    var observer = new MutationObserver(function () {
      applyHref(anchorEl.getAttribute('href') || '');
    });
    observer.observe(anchorEl, { attributes: true, attributeFilter: ['href'] });

    return observer;
  }


  function convertAnchorToInlineVideo(anchorEl) {
    if (!anchorEl) return;
    var href = (anchorEl.getAttribute('href') || '').trim();
    if (!href) return;

    var yIconEl = anchorEl.querySelector('.y-icon');
    var placeholderImg = anchorEl.querySelector('.placeHolderVideos');
    var thumbSrc = placeholderImg
      ? (placeholderImg.dataset.src || placeholderImg.dataset.original ||
         placeholderImg.currentSrc || placeholderImg.src)
      : '';

    var refs = buildVideoFrame({
      videoUrl: href,
      thumbSrc: thumbSrc,
      yIconEl: yIconEl,
      disabled: false,
      autoplayMuted: true
    });

    anchorEl.insertAdjacentElement('afterend', refs.frameEl);
    anchorEl.style.display = 'none';
    anchorEl.setAttribute('aria-hidden', 'true');
    anchorEl.setAttribute('tabindex', '-1');

    ensureYoutubeMessageHandler();

    armViewportAutoplay(refs);

    refs.facadeEl.addEventListener('click', function () {
      playUnmuted(refs);
    });
  }

  function initReactionsVideo() {
    var anchor = document.querySelector('.p-reactions .video-rectangle');
    convertAnchorToInlineVideo(anchor);
  }



  function initInstallationFallbackVideo(anchorEl) {
    var yIconEl = anchorEl.querySelector('.y-icon');
    var placeholderImg = anchorEl.querySelector('.placeHolderVideos');
    var thumbSrc = placeholderImg
      ? (placeholderImg.dataset.src || placeholderImg.dataset.original ||
         placeholderImg.currentSrc || placeholderImg.src)
      : '';

    var refs = buildVideoFrame({
      videoUrl: anchorEl.getAttribute('href') || '',
      thumbSrc: thumbSrc,
      yIconEl: yIconEl,
      disabled: true, 
      autoplayMuted: true
    });

    anchorEl.insertAdjacentElement('afterend', refs.frameEl);
    anchorEl.style.display = 'none';
    anchorEl.setAttribute('aria-hidden', 'true');
    anchorEl.setAttribute('tabindex', '-1');

    ensureYoutubeMessageHandler();

    refs.facadeEl.addEventListener('click', function () {
      playUnmuted(refs);
    });

    setupDynamicHrefVideo(anchorEl, refs);
  }


  function init() {
    initReactionsVideo();

    var button = document.getElementById(BUTTON_ID);
    var originalAnchor = document.querySelector(ANCHOR_SELECTOR);
    if (!button || !originalAnchor) return;

    var handle = button.dataset.handle;
    var jsonUrl = button.dataset.makeBasedInstallationVideos;

    getVideosJson(jsonUrl).then(function (data) {
      var videos = data && handle ? data[handle] : null;

      if (!videos || !videos.length) {

        initInstallationFallbackVideo(originalAnchor);
        return;
      }

      whenSwiperReady(function () {
        var container = originalAnchor.closest('.p-videosRight') || originalAnchor.parentElement;
        buildGallery(container, originalAnchor, videos);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();